class History{
    constructor(){
        this.history=[];
    }

    set(path){
        this.history.push(path);
    }

    get(){
        if(this.history.length>1){
            // remove current page from history
            // and go to last;
            this.history.pop();
            return this.history[this.history.length-1];
        }

        // no history to go back to? go to home page
        return "/";
    }


}

export let history = new History();